import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal, Button } from 'components';
import { CleanIcon, DownloadExcelIcon, PaymentIcon, ListIcon, BankIcon } from 'assets/icons';
import { PaymentService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: '',
	reference: '',
	status: ''
}

declare var window: any;

class BankPayments extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Referencia',
			'Banco Emisor',
			'Banco Receptor',
			'Teléfono',
			'Cédula Emisor (BNC)',
			'Concepto',
			'Monto',
			'Fecha',
			'Estatus',
			'Acciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		item: null,
		visible_payment: false,
		form_payment: {
			document_type_id: Constants.DOCUMENT_TYPES.V,
			document: '',
			name: '',
			password: ''
		},
		document_types: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Reporte Bancario',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await PaymentService.admin.bank.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD')
		});
		this.setState({
			data: res.payments?.rows || [],
			last_page: res.payments?.count || 1,
			document_types: res.document_types || []
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	changePayment = (e: any,callback = () => {}) => {
		this.setState({
			form_payment: {
				...this.state.form_payment,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	download = async () => {
		const res: any = await PaymentService.admin.bank.download({
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD')
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	refund = () => {
		if (!this.state.form_payment.document) {
			Globals.showWarning("El campo documento de identidad es requerido");
			return;
		}

		if (!this.state.form_payment.document_type_id) {
			Globals.showWarning("El campo tipo de documento es requerido");
			return;
		}

		if (!this.state.form_payment.name) {
			Globals.showWarning("El campo nombre del beneficiario es requerido");
			return;
		}

		if (!this.state.form_payment.password) {
			Globals.showWarning("Por favor, indique la contraseña para continuar");
			return;
		}

		Globals.confirm('¿Desea realizar la devolución de este pago? Esta acción no se puede deshacer',async () => {
			await PaymentService.admin.bank.refund({
				// @ts-ignore
				temporal_payment_id: this.state.item?.id,
				refund_document_type_id: this.state.form_payment.document_type_id,
				refund_document: this.state.form_payment.document,
				refund_name: this.state.form_payment.name,
				password: this.state.form_payment.password
			});
			Globals.showSuccess("Se ha reembolsado el pago correctamente");
			this.onClosePayment();
		});
	}

	onClosePayment = () => {
		this.setState({
			visible_payment: false,
			item: null,
			form_payment: {
				...this.state.form_payment,
				document_type_id: Constants.DOCUMENT_TYPES.V,
				document: '',
				name: '',
				password: ''
			}
		},() => {
			this.load();
		});
	}
	
	render() {
		const { visible_payment } = this.state;
		const item: any = this.state.item;

		return (
			<div id="admin-payments">
				<Modal
		          className="modal-refund"
		          visible={ visible_payment }
		          title="Reembolsar pago"
		          onClose={ () => this.onClosePayment() }
		        >
		          <div id="modal-refund">
		          	<p className="message">Por favor, confirme y complete los datos bancarios antes de continuar</p>
		          	<p><span className="bold">Banco:</span> { item?.bank?.name }</p>
		          	<p><span className="bold">Teléfono:</span> { item?.ClientPhone?.replace(/^0058/, "0") }</p>
		          	<div className="row">
		          		<div className="col-md-3">
							<Select
								placeholder="Seleccionar"
								label="Tipo"
								color="white"
								name="document_type_id"
								onChange={ (e: any) => this.changePayment(e) }
								value={ this.state.form_payment.document_type_id }
								options={ this.state.document_types.filter((i: any) => i.id == Constants.DOCUMENT_TYPES.V || i.id == Constants.DOCUMENT_TYPES.E).map((item: any) => {
									return {
										value: item.id,
										label: item.name
									}
								}) } />
						</div>
						<div className="col-md-9">
							<Input
								type="number"
								value={ this.state.form_payment.document }
								name="document"
								label="Cédula"
								maxLength={ 8 }
								onChange={ this.changePayment } />
						</div>
						<div className="col-md-12">
							<Input
								value={ this.state.form_payment.name }
								name="name"
								label="Nombre del Beneficiario"
								onChange={ this.changePayment } />
						</div>
						<div className="col-md-12">
							<Input
								type="password"
								value={ this.state.form_payment.password }
								name="password"
								label="Contraseña"
								onChange={ this.changePayment } />
						</div>
		          	</div>
		          	<div className="row">
		          		<div className="col-md-12">
		          			<div className="text-center">
								<Button type="submit" className="btn-save" onClick={ () => this.refund() }>
									Reembolsar
								</Button>
							</div>
		          		</div>
		          	</div>
		          </div>
		      	</Modal>

				<div className="row row-tabs">
					<div className="col-md-4">
						<Link to="/admin/payments">
							<div className="item-tab">
								<img src={ PaymentIcon } />
								<p>Pagos de cuotas</p>
							</div>
						</Link>
					</div>
					<div className="col-md-4">
						<Link to="/admin/partial-payments">
							<div className="item-tab">
								<img src={ ListIcon } />
								<p>Pagos parciales</p>
							</div>
						</Link>
					</div>
					<div className="col-md-4">
						<Link to="/admin/bank-payments">
							<div className="item-tab active">
								<img src={ BankIcon } />
								<p>Reporte Bancario</p>
							</div>
						</Link>
					</div>
				</div>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="row col-md-11">
								<div className="col-md">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Banco de origen o teléfono"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<DatePicker
										label="Desde"
										placeholder="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md">
									<DatePicker
										label="Hasta"
										placeholder="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
								<div className="col-md">
									<Input
										value={ this.state.form.reference }
										name="reference"
										placeholder="Buscar"
										label="Referencia"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<Select
										placeholder="Seleccionar"
										label="Estatus"
										name="status"
										color="white"
										onChange={ (e: any) => this.change(e,async () => {
											this.load(true);
										}) }
										value={ this.state.form.status }
										options={ [
											{ value: Constants.TEMPORAL_PAYMENT_STATUS.ACTIVE.toString() , label: 'Activos' },
											{ value: Constants.TEMPORAL_PAYMENT_STATUS.INACTIVE.toString() , label: 'Inactivos' },
											{ value: Constants.TEMPORAL_PAYMENT_STATUS.REFUND.toString() , label: 'Reembolsados' }
										] } />
								</div>
							</div>
							<div className="col-md-1">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Reporte Bancario" data={ this.state.data.length } header={ this.state.header } titleRight={
					<React.Fragment>
						{
							this.state.data.length > 0 && (
								<div className="container-add-table">
									<p>Descargar Excel</p>
									<button className="btn add-btn-table" onClick={ this.download }>
										<img src={ DownloadExcelIcon } />
									</button>
								</div>
							)
						}
					</React.Fragment>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.OriginBankReference }</td>
								<td>{ i.OriginBankCode }</td>
								<td>{ i.DestinyBankCode }</td>
								<td>{ i.ClientPhone }</td>
								<td>{ i.ClientID || '-' }</td>
								<td>{ i.Concept === 'null' ? '' : i.Concept }</td>
								<td>{ Globals.formatMiles(i.Amount,true,'Bs.') }</td>
								<td>{ moment(i.created_at).format('DD/MM/YYYY HH:mm') }</td>
								<td>{ i.status_text }</td>
								<td>
									{
										i.status != Constants.TEMPORAL_PAYMENT_STATUS.REFUND && checkPermission(Constants.MODULES.PAYMENTS,'write') && (
											<button className="btn btn-valid" onClick={ () => {
												const prefix = i.ClientID?.charAt(0) || '';
												// @ts-ignore
												const document_type_id = Constants.DOCUMENT_TYPES[prefix] || Constants.DOCUMENT_TYPES.V;

												this.setState({
													visible_payment: true,
													item: i,
													form_payment: {
														...this.state.form_payment,
														name: i.refund_name || '',
														document: i.ClientID?.slice(1) || '',
														document_type_id
													}
												});
											} }>
												Reembolsar
											</button>
										)
									}
									{
										i.status == Constants.TEMPORAL_PAYMENT_STATUS.REFUND && i.refund_reference && (
											<p><span className="bold">Reembolso:</span> { i.refund_reference }</p>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(BankPayments);